export type Logger = Pick<Console, 'log' | 'warn' | 'error'>
export function useLogger(): Logger {
  return console
}
